import { error } from 'jquery'
import React, { useState } from 'react'
import { ChevronDown } from 'react-feather'
import GridModal from './Modals/GridModal';

const SelectDropDown = ({disabledInput,productImage,labelName, page, requiredStar, options = [], selectedValue, onChange = ()=>{}, setSelectedValue, msg, disabled=false, hasImage=false, openDropdown, setOpenDropdown }) => {

    const [showOptions, setShowOptions] = useState(false);
    function clearSelected() {
        setShowOptions(false)
    }
    React.useEffect(() => {
        function clearSelected(e) {
            e.stopPropagation();
            if(showOptions) {
                
                setShowOptions(false)

            }
        }
        window.addEventListener("click", clearSelected);
        return () => window.removeEventListener("click", clearSelected);
      }, [showOptions]);

    React.useEffect(() => {
        if (!showOptions && page === 'searchFilter') {
            setSearchTerm('');
        }
    }, [showOptions, page]);

    const handleOptionClick = (option) => {
        if(disabled)
            return
        // setSelectedOption(option);
        setSelectedValue(option)
        setShowOptions(false);
        onChange(option);
    }
    const handleShowDropdownClick = (e) => {
        e.stopPropagation();
        if(disabled)
            return;
        setShowOptions(!showOptions);
    };
    const [searchTerm, setSearchTerm] = useState('');
    const filteredOptions = options && Array.isArray(options) ? options.filter((option) => {
        return option.title && option.title.toLowerCase().includes(searchTerm.toLowerCase());
    }) : [];
      const handleSearch = (event) => {
        setSearchTerm(event.target.value);
      };

      function onClickHandler(e) {
        e.stopPropagation();
        
      }
    return (
        <>
            <div className={`selectBoxWrap ${disabledInput == false ? 'disabledInput' :'' }`}>
                <label className='selectDropBoxLabel form-label'>{labelName} <span className="redStar">{requiredStar}</span></label>
                <div className={`selectDropBox ${disabled? 'disabled' : ""}`} onClick={handleShowDropdownClick}>
                    <div className='registrationTopText'>
                        <p className="mb-0">{selectedValue?.title ? selectedValue.title.substring(0, 99) : <span style={{ color: 'grey' }}>Select</span>}</p>
                        {!disabled && <div className='arrow-icon'> {<ChevronDown />}</div>}
                        {/* <p className="mb-0">{selectedValue?.title ? selectedValue.title : <span style={{ color: 'grey' }}>Select</span>}</p>
                        {!disabled && <div className='arrow-icon'> {<ChevronDown />}</div>} */}
                    </div>
                        
                </div>
                {page !='searchFilter'  &&  showOptions && !hasImage &&
                    <div className='selectDropDownOptionBox'>

                        <ul>
                            {options.map((option, index) => (
                                <li
                                    key={index}
                                    onClick={() => handleOptionClick(option)}
                                    className={`${selectedValue.title === option.title ? 'selectedOption' : ''} ${option.productImage != null ? 'selectedBlockWithImage' : ''}`}

                                >
                                    {option.title}  {option.productImage != null && (<span className='optionImage'><img src = {option.productImage} alt = {option.title}/></span>)}
                                </li>
                            ))}
                        </ul>
                    </div>
                }
                {page == 'searchFilter' && showOptions &&
                    <div className='selectDropDownOptionBox coloredOptionBox'>
                        <div className='srchFilterBox'  onClick={onClickHandler}>
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={handleSearch} 
                                
                            />
                        </div>
                        <ul>
                            {filteredOptions.map((option) => (
                                <li
                                    key={option.id}
                                    onClick={() => handleOptionClick(option)}
                                    // className={selectedValue.title === option.title ? 'selectedOption' : ''}
                                    className={selectedValue.id === option.id ? 'selectedOption' : ''}
                                >
                                     {option.title}  {option.productImage != null && (<span className='optionImage'><img src = {option.productImage} alt = {option.title}/></span>)}
                                </li>
                            ))}
                        </ul>
                    </div>
                }

                {/* <span className='error-message'>{msg}</span> */}
                {hasImage && <GridModal title={labelName} show={showOptions} data={options} hasImage={true} selected={selectedValue} setSelected={setSelectedValue}  />}

            </div>

        </>
    )
}

export default SelectDropDown
